var _g;

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgRomania(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 17,
    viewBox: "85.333 85.333 24 17",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    strokeWidth: 0.048317
  }, /*#__PURE__*/React.createElement("rect", {
    x: 85.333,
    y: 85.333,
    width: 24,
    height: 16.999,
    fill: "#ffda44"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 85.333,
    y: 85.333,
    width: 7.9998,
    height: 17,
    fill: "#0052b4"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 101.33,
    y: 85.333,
    width: 7.9998,
    height: 17,
    fill: "#d80027"
  }))));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRomania);
export default __webpack_public_path__ + "static/media/romania.0f2929c7cb463a4c6466f20a1d8626c7.svg";
export { ForwardRef as ReactComponent };